<template>
  <div
    class="row"
    style="margin-left: 0 !important; margin-right: 0 !important;"
  >
    <div class="column left">
      <Scrollbar
        :style="scrollStyle"
        class="fixHeight"
        style="border-right: 1px solid #ddd;"
      >
        <MenuSider>
          <slot name="MenuSider" slot="main" />
        </MenuSider>
      </Scrollbar>
    </div>
    <div class="middle-right">
      <div class="horizontal" v-if="!hideTopHorizontal">
        <slot name="TopHorizontal" />
      </div>
      <div
        class="column middle"
        :style="{ ...borderLeftAndRight, ...middleStyle }"
      >
        <Scrollbar
          :style="{ ...scrollStyle, ...fixHeightMiddle }"
          class="fixHeightMiddle"
          style="position: relative;"
          :minSize="0.3"
        >
          <a-affix :offsetTop="topbarHeight">
            <slot name="ListItemToolbar" />
          </a-affix>
          <slot name="ListItem" />
        </Scrollbar>
      </div>
      <div class="column right" v-if="showRight">
        <Scrollbar
          :style="{ ...scrollStyle, ...fixHeightMiddle }"
          class="fixHeightMiddle"
        >
          <transition :name="settings.routerAnimation" mode="out-in">
            <router-view> </router-view>
          </transition>
        </Scrollbar>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Scrollbar from "vue-custom-scrollbar";
import MenuSider from "./MenuSider.vue";

const shortBorder = "1px solid #ddd !important";
export default {
  components: { MenuSider, Scrollbar },
  computed: mapState(["settings"]),
  props: {
    hideTopHorizontal: { type: Boolean },
    showRight: { type: Boolean },
  },
  data() {
    return {
      // scrollStyle: { overflow: "auto" },
      scrollStyle: { overflow: "auto", maxHeight: "100vh" },
      borderLeftAndRight: {
        borderRight: shortBorder,
        // borderLeft: shortBorder,
        // margin: "5px",
        // padding: "5px",
        backgroundColor: "#fff",
      },
      topbarHeight: 50,
      middleStyle: { width: "100%" },
      fixHeightMiddle: {},
    };
  },
  watch: {
    showRight() {
      this.checkRightColumn();
    },
    hideTopHorizontal() {
      this.checkTopHorizontal();
    },
  },
  methods: {
    changeItem(id, type = "view") {
      this.$router.push({ path: `/approval/${type}/${id}` });
    },
    checkTopHorizontal() {
      if (this.hideTopHorizontal) {
        this.topbarHeight = 50;
        this.fixHeightMiddle = { height: "calc(100vh - 50px) " };
      } else {
        this.topbarHeight = 100;
        this.fixHeightMiddle = { height: "calc(100vh - 100px) " };
      }
    },
    checkRightColumn() {
      if (this.showRight) {
        this.middleStyle = { width: "500px" };
      } else {
        this.middleStyle = { width: "100%" };
      }
    },
    collaspeRight(bool) {
      if (bool) this.showRight = true;
      else this.showRight = false;
    },
  },
  created() {
    this.checkRightColumn();
    this.checkTopHorizontal();
  },
};
</script>
<style lang="css" scoped>
/* Set additional styling options for the columns */
.column {
  float: left;
}
/* Set width length for the left, right and middle columns */
.left {
  width: 250px;
}
/* .middle {
  width: 500px;
} */
.right {
  width: calc(100% - 500px);
  border-left: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
.middle {
  border-left: 0 !important;
  border-right: 0 !important;
  margin: 0 !important;
  overflow-x: hidden !important;
}
.fixHeight {
  height: calc(100vh - 50px);
  position: relative !important;
  max-height: 100vh;
}
.fixHeightMiddle {
  max-height: 100vh !important;
  padding: 0 !important;
}
.row:after {
  content: "";
  display: table;
  clear: both;
}

.middle-right {
  width: calc(100% - 250px);
  overflow-x: hidden !important;
  /* padding: 0 5px; */
}

.horizontal {
  border-top: 0 !important;
  max-height: 50px;
  height: 50px;
  padding: 10px;
  border: 1px solid #eee;
}
</style>

<style>
body {
  overflow: hidden;
}
</style>
